import { queryOptions } from "@tanstack/react-query";
import { PUBLIC_QUERY_STALE_TIME } from "./public-query-cache";
import { adminListPosts, getPublishedPost, listPublishedPostSummaries } from "@/lib/blog.functions";

export const publishedPostsQuery = queryOptions({
  queryKey: ["blog", "published"],
  staleTime: PUBLIC_QUERY_STALE_TIME,
  queryFn: () => listPublishedPostSummaries(),
});

export const publishedPostQuery = (slug: string) =>
  queryOptions({
    queryKey: ["blog", "post", slug],
    staleTime: PUBLIC_QUERY_STALE_TIME,
    queryFn: () => getPublishedPost({ data: { slug } }),
  });

export const adminPostsQuery = queryOptions({
  queryKey: ["blog", "admin", "list"],
  queryFn: () => adminListPosts(),
});
